// Forms: field validity, populated and dirty state, form-wide behaviour, nested and dynamic sections. Every app with a
// form needs it. The heavier widgets are opt-in: forms/tom_select, forms/flatpickr and forms/autonumeric.
import {
  AutosizeController,
  AutoSubmitFormController,
  PresenceController,
  SignalAttributeSyncController,
  SignalContentSyncController,
  SignalDisableController,
  SignalDomChildrenController,
  SignalEnableController,
  SignalInputController,
  SignalVisibilityController
} from 'stimulus-library'
import DynamicFormSectionController from '../../view_components/forms/dynamic_form_section/dynamic_form_section'
import BusyFormController from './controllers/busy_form_controller'
import FormController from './controllers/form_controller'
import InjectFormDataController from './controllers/inject_form_data_controller'
import InvalidFieldController from './controllers/invalid_field_controller'
import NestedFormController from './controllers/nested_form_controller'
import PopulatedFieldsController from './controllers/populated_fields_controller'
import PopulatedFieldsetController from './controllers/populated_fieldset_controller'
import PreventEnterController from './controllers/prevent_enter_controller'
import SummationController from './controllers/summation_controller'

export function register(application) {
  application.register('autosize', AutosizeController)
  application.register('auto-submit-form', AutoSubmitFormController)
  application.register('presence', PresenceController)
  application.register('signal-attribute', SignalAttributeSyncController)
  application.register('signal-text', SignalContentSyncController)
  application.register('signal-disable', SignalDisableController)
  application.register('signal-count', SignalDomChildrenController)
  application.register('signal-enable', SignalEnableController)
  application.register('signal-input', SignalInputController)
  application.register('signal-visibility', SignalVisibilityController)
  application.register('dynamic-section', DynamicFormSectionController)
  application.register('busy-form', BusyFormController)
  application.register('core-form', FormController)
  application.register('inject-form-data', InjectFormDataController)
  application.register('invalid-field', InvalidFieldController)
  application.register('nested-form', NestedFormController)
  application.register('populated-fields', PopulatedFieldsController)
  application.register('populated-fieldset', PopulatedFieldsetController)
  application.register('prevent-enter', PreventEnterController)
  application.register('summation', SummationController)
}
